export default __webpack_public_path__ + "static/media/Chef-5.3e2e5c72.jpg";